module.exports = __webpack_public_path__ + "static/media/Drilling.40c3e85b.mp3";